import { render, staticRenderFns } from "./UrbanismDocument.vue?vue&type=template&id=02ab957a&"
import script from "./UrbanismDocument.vue?vue&type=script&lang=js&"
export * from "./UrbanismDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports